import { render } from "./TheCartOrderPay.vue?vue&type=template&id=f4e98dac"
import script from "./TheCartOrderPay.vue?vue&type=script&lang=js"
export * from "./TheCartOrderPay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__